import { Input } from '../../../ui/Input';
import type { QuestionDefinition } from '../../../../types/checkin';

interface TextQuestionProps {
  question: QuestionDefinition;
  value: string | undefined;
  onChange: (value: string) => void;
}

export function TextQuestion({
  question,
  value = '',
  onChange,
}: TextQuestionProps) {
  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={question.placeholder}
      maxLength={question.maxLength}
    />
  );
}
